// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Общий контейнер для страницы */
.print-dispatcher-container {
    display: flex;
    padding: 20px;
  }
  
  /* Боковая панель для фильтрации по датам и списка маршрутов */
  .print-sidebar {
    width: 250px;
    padding-right: 20px;
    border-right: 2px solid #ccc;
  }
  
  /* Стили для строк фильтрации по датам */
  .date-filter-row {
    margin-bottom: 20px;
  }
  
  /* Стили для списка маршрутов */
  .print-routes-list {
    list-style-type: none;
    padding: 0;
  }
  
  .print-routes-list li {
    margin-bottom: 10px;
    padding: 10px;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 5px;
    transition: background-color 0.3s ease;
  }
  
  .print-routes-list li:hover {
    background-color: #e6f7ff; /* Подсветка при наведении */
  }
  
  /* Выделение выбранного маршрута */
  .print-routes-list li.selected {
    background-color: #cce5ff; /* Цвет фона для выбранного маршрута */
    border-color: #66b3ff;
  }
  


  /* Контейнер для данных маршрута */
  .print-route-details {
    flex: 1 1;
    padding-left: 20px;
  }
  
  /* Заголовки */
  h2, h3 {
    margin: 10px 0;
    text-align: center;
  }
  
  /* Стиль таблицы */
  .print-order-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
  }
  
  /* Стили для ячеек таблицы */
  th, td {
    border: 2px solid black;
    padding: 8px;
    text-align: left;
  }
  
  /* Заголовок таблицы */
  th {
    background-color: #f2f2f2;
    text-align: center;
  }
  
  /* Стили для четных строк в таблице */
  tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  /* Стили для итоговой строки 
  tr:last-child {
    font-weight: bold;
    background-color: #f2f2f2;
    font-size: 16px;
    text-align: right;
  }*/
  
  /* Стили для скрытых элементов при печати */
  @media print {
    body {
      margin: 20px;
    }
  
    .print-sidebar {
      display: none; /* Скрыть боковую панель при печати */
    }
  
    button {
      display: none; /* Скрыть кнопки при печати */
    }
  
    h2, h3 {
      text-align: center;
    }
  
    .print-routes-list li {
      background-color: transparent;
      border: none;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/modules/Developer/ExamplePages/PrintRoutesPage/PrintRoutes.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;IACI,aAAa;IACb,aAAa;EACf;;EAEA,8DAA8D;EAC9D;IACE,YAAY;IACZ,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA,wCAAwC;EACxC;IACE,mBAAmB;EACrB;;EAEA,+BAA+B;EAC/B;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,sCAAsC;EACxC;;EAEA;IACE,yBAAyB,EAAE,4BAA4B;EACzD;;EAEA,kCAAkC;EAClC;IACE,yBAAyB,EAAE,sCAAsC;IACjE,qBAAqB;EACvB;;;;EAIA,kCAAkC;EAClC;IACE,SAAO;IACP,kBAAkB;EACpB;;EAEA,cAAc;EACd;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA,kBAAkB;EAClB;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA,4BAA4B;EAC5B;IACE,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;EAClB;;EAEA,sBAAsB;EACtB;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA,qCAAqC;EACrC;IACE,yBAAyB;EAC3B;;EAEA;;;;;;IAME;;EAEF,2CAA2C;EAC3C;IACE;MACE,YAAY;IACd;;IAEA;MACE,aAAa,EAAE,qCAAqC;IACtD;;IAEA;MACE,aAAa,EAAE,6BAA6B;IAC9C;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,6BAA6B;MAC7B,YAAY;IACd;EACF","sourcesContent":["/* Общий контейнер для страницы */\r\n.print-dispatcher-container {\r\n    display: flex;\r\n    padding: 20px;\r\n  }\r\n  \r\n  /* Боковая панель для фильтрации по датам и списка маршрутов */\r\n  .print-sidebar {\r\n    width: 250px;\r\n    padding-right: 20px;\r\n    border-right: 2px solid #ccc;\r\n  }\r\n  \r\n  /* Стили для строк фильтрации по датам */\r\n  .date-filter-row {\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  /* Стили для списка маршрутов */\r\n  .print-routes-list {\r\n    list-style-type: none;\r\n    padding: 0;\r\n  }\r\n  \r\n  .print-routes-list li {\r\n    margin-bottom: 10px;\r\n    padding: 10px;\r\n    background-color: #f9f9f9;\r\n    border: 1px solid #ddd;\r\n    cursor: pointer;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    border-radius: 5px;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n  \r\n  .print-routes-list li:hover {\r\n    background-color: #e6f7ff; /* Подсветка при наведении */\r\n  }\r\n  \r\n  /* Выделение выбранного маршрута */\r\n  .print-routes-list li.selected {\r\n    background-color: #cce5ff; /* Цвет фона для выбранного маршрута */\r\n    border-color: #66b3ff;\r\n  }\r\n  \r\n\r\n\r\n  /* Контейнер для данных маршрута */\r\n  .print-route-details {\r\n    flex: 1;\r\n    padding-left: 20px;\r\n  }\r\n  \r\n  /* Заголовки */\r\n  h2, h3 {\r\n    margin: 10px 0;\r\n    text-align: center;\r\n  }\r\n  \r\n  /* Стиль таблицы */\r\n  .print-order-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    margin-top: 20px;\r\n  }\r\n  \r\n  /* Стили для ячеек таблицы */\r\n  th, td {\r\n    border: 2px solid black;\r\n    padding: 8px;\r\n    text-align: left;\r\n  }\r\n  \r\n  /* Заголовок таблицы */\r\n  th {\r\n    background-color: #f2f2f2;\r\n    text-align: center;\r\n  }\r\n  \r\n  /* Стили для четных строк в таблице */\r\n  tr:nth-child(even) {\r\n    background-color: #f9f9f9;\r\n  }\r\n  \r\n  /* Стили для итоговой строки \r\n  tr:last-child {\r\n    font-weight: bold;\r\n    background-color: #f2f2f2;\r\n    font-size: 16px;\r\n    text-align: right;\r\n  }*/\r\n  \r\n  /* Стили для скрытых элементов при печати */\r\n  @media print {\r\n    body {\r\n      margin: 20px;\r\n    }\r\n  \r\n    .print-sidebar {\r\n      display: none; /* Скрыть боковую панель при печати */\r\n    }\r\n  \r\n    button {\r\n      display: none; /* Скрыть кнопки при печати */\r\n    }\r\n  \r\n    h2, h3 {\r\n      text-align: center;\r\n    }\r\n  \r\n    .print-routes-list li {\r\n      background-color: transparent;\r\n      border: none;\r\n    }\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
